module.exports = __webpack_public_path__ + "static/media/pix.2bc1c5eb.png";